import { Browser } from 'detect-browser';

export const unsupportedBrowsers: Browser[] = ['ie'];
